import { getStatuses } from '../../lib/statuses'
import { Key } from './Key'
import { useEffect } from 'react'
import { ENTER_TEXT, DELETE_TEXT } from '../../constants/strings'
import { GateType, gateLatexContent, gateTitleMap } from '../../constants/gates'
import { LatexTooltip } from '../Tooltip'
// import { localeAwareUpperCase } from '../../lib/words'

type Props = {
  onChar: (value: string) => void
  onDelete: () => void
  onEnter: () => void
  guesses: string[]
  solution: string
  isRevealing?: boolean
  showAnnotations: boolean
}

const VALID_KEYS = [
  'H',
  'X',
  'Y',
  'Z',
  'S',
  'T',
  'I',
  '|',
  '\\',
  '>',
  '.',
  '⟩',
  '+',
  '-',
  '0',
  '1',
  'i',
  '=',
]

const autoUpperCaseChars = ['h', 'x', 'y', 'z', 's', 't']

export const Keyboard = ({
  onChar,
  onDelete,
  onEnter,
  guesses,
  solution,
  isRevealing,
  showAnnotations,
}: Props) => {
  const charStatuses = getStatuses(guesses, solution)

  const onClick = (value: string) => {
    if (value === 'ENTER') {
      onEnter()
    } else if (value === 'DELETE') {
      onDelete()
    } else {
      onChar(value)
    }
  }

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === 'Enter') {
        onEnter()
      } else if (e.code === 'Backspace') {
        onDelete()
      } else {
        let key = e.key
        if (key.length === 1 && autoUpperCaseChars.indexOf(key) !== -1) {
          onChar(key.toUpperCase())
        }
        if (key.length === 1 && VALID_KEYS.indexOf(key) !== -1) {
          switch (key) {
            case '.':
            case '>':
              onChar('⟩')
              break
            case '\\':
              onChar('|')
              break
            default:
              onChar(key)
          }
        }
      }
    }
    window.addEventListener('keyup', listener)
    return () => {
      window.removeEventListener('keyup', listener)
    }
  }, [onEnter, onDelete, onChar])

  return (
    <div>
      <div className="flex justify-center mb-1">
        {['H', 'X', 'Y', 'Z', 'S', 'T', 'I'].map((key) => (
          <LatexTooltip
            key={key}
            enabled={showAnnotations}
            contentLatex={gateLatexContent[key as GateType]}
            title={gateTitleMap[key as GateType]}
          >
            <Key
              value={key}
              onClick={onClick}
              status={charStatuses[key]}
              isRevealing={isRevealing}
            />
          </LatexTooltip>
        ))}
      </div>
      <div className="flex justify-center mb-1">
        {['|', '⟩', '+', '-', '0', '1', 'i', '='].map((key) => (
          <Key
            value={key}
            key={key}
            onClick={onClick}
            status={charStatuses[key]}
            isRevealing={isRevealing}
          />
        ))}
      </div>
      <div className="flex justify-center">
        <Key width={65.4} value="ENTER" onClick={onClick}>
          {ENTER_TEXT}
        </Key>
        {/*{['Z', 'X', 'C', 'V', 'B', 'N', 'M'].map((key) => (*/}
        {/*  <Key*/}
        {/*    value={key}*/}
        {/*    key={key}*/}
        {/*    onClick={onClick}*/}
        {/*    status={charStatuses[key]}*/}
        {/*    isRevealing={isRevealing}*/}
        {/*  />*/}
        {/*))}*/}
        <Key width={65.4} value="DELETE" onClick={onClick}>
          {DELETE_TEXT}
        </Key>
      </div>
    </div>
  )
}
